"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = void 0;
var p5_1 = require("p5");
var defaultConfig = {
    xPos: 0,
    yPos: 0,
    zPos: 0,
    excusionZone: 10,
    attraction: 1
};
var create = function (config) {
    if (config === void 0) { config = {}; }
    var _a = __assign(__assign({}, defaultConfig), config), xPos = _a.xPos, yPos = _a.yPos, zPos = _a.zPos, excusionZone = _a.excusionZone, attraction = _a.attraction;
    var _attraction = 0 - attraction;
    var _excusionZone = excusionZone;
    var _position = new p5_1.Vector();
    _position.set(xPos, yPos, zPos);
    return {
        run: function (boids) {
            for (var i = 0; i < boids.length; i++) {
                var boid = boids[i];
                var boidVec = new p5_1.Vector();
                var _a = boid.getPosition(), x = _a.x, y = _a.y;
                boidVec.set(x, y);
                boidVec.sub(_position);
                if (boidVec.mag() < _excusionZone) {
                    boidVec.mult(_attraction);
                    boids[i].applyForce(boidVec);
                }
            }
        },
        setExclusionZone: function (value) {
            _excusionZone = value;
        },
        getExclusionZone: function () {
            return _excusionZone;
        },
        setAttraction: function (value) {
            _attraction = 0 - value;
        },
        getAttraction: function () {
            return _attraction;
        },
        setPosition: function (value) {
            _position = value;
        },
        getPosition: function () {
            return _position;
        }
    };
};
exports.create = create;
